import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Employment from "./pages/Employment";
import BehaviourTherapy from "./pages/BehaviourTherapy";
import SpeechLanguageTherapy from "./pages/SpeechLanguageTherapy";
import OccupationalTherapy from "./pages/OccupationalTherapy";
import AideServices from "./pages/AideServices";
import RespiteServices from "./pages/RespiteServices";
import FscdPartnership from "./pages/FscdPartnership";
import FscdCoordinationServices from "./pages/FscdCoordinationServices";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateLessonsOverview from "./pages/PrivateLessonsOverview";
import ElementaryLessons from "./pages/ElementaryLessons";
import JuniorHigh from "./pages/JuniorHigh";
import SeniorHigh from "./pages/SeniorHigh";
import IbAndAp from "./pages/IbAndAp";
import UniversityAdmission from "./pages/UniversityAdmission";
import PediatricDevelopmentalSessions from "./pages/PediatricDevelopmentalSessions";
import AdultDevelopmentalSessions from "./pages/AdultDevelopmentalSessions";
import Profiles from "./pages/Profiles";
import Pdd from "./pages/Pdd";

const App = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/services" element={<Services />} />
          <Route exact path="/our-team" element={<Profiles />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/work-with-us" element={<Employment />} />
          <Route
            exact
            path="/behaviour-therapy"
            element={<BehaviourTherapy />}
          />
          <Route
            exact
            path="/speech-therapy"
            element={<SpeechLanguageTherapy />}
          />
          <Route
            exact
            path="/occupational-therapy"
            element={<OccupationalTherapy />}
          />
          <Route
            exact
            path="/pediatric-developmental-sessions"
            element={<PediatricDevelopmentalSessions />}
          />
          <Route
            exact
            path="/adult-developmental-sessions"
            element={<AdultDevelopmentalSessions />}
          />
          <Route exact path="/pdd" element={<Pdd />} />
          <Route exact path="/aide-services" element={<AideServices />} />
          <Route exact path="/respite-services" element={<RespiteServices />} />
          <Route exact path="/fscd-partnership" element={<FscdPartnership />} />
          <Route
            exact
            path="/fscd-coordination-services"
            element={<FscdCoordinationServices />}
          />
          <Route
            exact
            path="/private-lessons-overview"
            element={<PrivateLessonsOverview />}
          />
          <Route
            exact
            path="/kindergarten-to-grade-6"
            element={<ElementaryLessons />}
          />
          <Route exact path="/junior-high" element={<JuniorHigh />} />
          <Route exact path="/senior-high" element={<SeniorHigh />} />
          <Route exact path="/ib-and-ap" element={<IbAndAp />} />
          <Route
            exact
            path="/university-admission"
            element={<UniversityAdmission />}
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
